import React, { useEffect, useState } from 'react';
import { groupBy } from '../../../Functions/datasArrange';
import axiosInstance from '../../../services/AxiosInstance';
import GoBackButton from '../../../components/GoBackButton';

const Notifications = () => {

    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = () => {
        axiosInstance(`notification/?for_joc=true`, { method: "GET" })
            .then(res => {
                setNotifications(res?.data)
            })
            .catch(err => console.log('err in notifications: ', err))
    }

    const handleClear = () => {
        axiosInstance(`notification/?delete_ids=${notifications.map(a => a.id)}`, { method: "DELETE" })
            .then(res => {
                if (res.status === 204) getData();
            })
    }

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white p-b20">
                    <div className="container">
                        <div className="job-bx browse-job clearfix">
                            <div className="job-bx-title clearfix">
                                <h5 className="font-weight-700 pull-left text-uppercase">Notifications</h5>
                                <GoBackButton />
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="card" style={{ backgroundColor: "aquamarine" }}>
                                        <div class="card-body">
                                            <div className="d-flex justify-content-between">
                                                <h5 class="card-title">Users</h5>
                                                <i className="fa fa-trash text-danger cursor-pointer" title="Click to delete all the notifications" onClick={() => handleClear()} />
                                            </div>
                                            {
                                                groupBy(notifications, 'n_type')?.profile?.map((res, index) => {
                                                    return (
                                                        <div
                                                            className="cursor-pointer" >
                                                            {index + 1}. <label><strong>{res?.message}</strong></label> user is registered in portal
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="card" style={{ backgroundColor: "#dafffd" }}>
                                        <div class="card-body">
                                            <div className="d-flex justify-content-between">
                                                <h5 class="card-title">Jobs</h5>
                                                <i className="fa fa-trash text-danger cursor-pointer" title="Click to delete all the notifications" onClick={() => handleClear()} />
                                            </div>
                                            {
                                                groupBy(notifications, 'n_type')?.job?.map((res, index) => {
                                                    return (
                                                        <div
                                                            className="mt-1 cursor-pointer">
                                                            {index + 1}. {res?.message}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notifications;